import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 294.19 390.23"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={336.11}
        y1={437.15}
        x2={95.41}
        y2={44.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f37331" />
        <stop offset={0.76} stopColor="#f8ae3a" />
      </linearGradient>
    </defs>
    <path
      d="M219.15 208.47c-3.33-9.27-3.4-19.45 1.48-29.91l71.95-154.29a16.957 16.957 0 0 0-1.07-16.37c-3.14-4.94-8.53-7.9-14.39-7.9H98.66c-3.26 0-6.42.92-9.16 2.67a17.109 17.109 0 0 0-6.3 7.18L4.72 178.15c-6.75 11.81-5.87 22.86.15 34.24l78.34 168a17.06 17.06 0 0 0 6.29 7.17c2.75 1.75 5.91 2.68 9.17 2.68h178.46c5.87 0 11.24-2.96 14.39-7.89 3.15-4.94 3.55-11.06 1.07-16.38l-73.43-157.49Zm34.33-179.33c.12 0 .55.03.81.44.25.4.13.76.07.91l-59.47 127.55-70.61-128.9h129.2ZM96.57 339.29 34.85 207.71a27.634 27.634 0 0 1-2.63-11.78c-.01-4.11.86-8.07 2.59-11.8L96.18 51.92l74.83 135.79c1.29 2.34 1.96 4.97 1.96 7.63.01 2.67-.67 5.32-1.95 7.68L96.56 339.29Zm157.26 21.37c-.24.39-.65.43-.8.43H119.35l75.25-133.97 59.3 132.6c.05.11.2.51-.07.94Z"
      style={{
        fill: "url(#a)",
      }}
    />
  </svg>
)

export default SvgComponent
